export default import.meta.ROLLDOWN_FILE_URL_0ab4_SF2cYHJR5T4FIuGpw